import type { App } from "vue";

const EdroneComponentNamePlugin = {
  install(app: App) {
    app.mixin({
      mounted() {
        const componentName = this.$options.name || this.$options.__name;

        if (!componentName) return;

        if (this.$el instanceof HTMLElement) {
          this.$el.setAttribute("data-edrone-name", componentName);
        } else if (this.$el?.nodeType === Node.TEXT_NODE || this.$el?.nodeType === Node.COMMENT_NODE) {
          const firstElement = this.$el.nextElementSibling;
          if (firstElement instanceof HTMLElement) {
            firstElement.setAttribute("data-edrone-name", componentName);
          }
        }
      },
    });
  },
};

export default EdroneComponentNamePlugin;
